const SET_MAP_VIEW = 'SET_MAP_VIEW';

const initialState = {
	currentMap: null,
	streetViewMode: 'satellite',
};

export const setMapView = (currentMap, streetViewMode = 'satellite') => ({
	type: SET_MAP_VIEW,
	payload: {
		currentMap,
		streetViewMode,
	}
});

const mapReducer = (state = initialState, action) => {
	switch (action.type) {
		case SET_MAP_VIEW:
			return {
				...state,
				...action.payload,
			};
		default:
			return state;
	}
};

export default mapReducer;